import { Card, Select, Space, Table, theme } from 'antd'
import React from 'react'
import { hexToRGBA, toCamelCase } from '../../../lib/utils'
import { CarePlanTemplatesNewRecordVisitsColumnTemplate } from '../../Chronic Care Plans/utils/templates'

// Standard specialist types - in a real app, this would be dynamic based on the planType
const DEFAULT_SPECIALIST_TYPES = [
  'Allergist',
  'Anesthesiologist',
  'Cardiologist',
  'Dermatologist',
  'Endocrinologist',
  'Gastroenterologist',
  'Hematologist',
  'Infectious Disease Specialist',
  'Internist',
  'Nephrologist',
  'Neurologist',
  'Obstetrician/Gynecologist',
  'Oncologist',
  'Ophthalmologist',
  'Orthopedic Surgeon',
  'Otolaryngologist (ENT)',
  'Pediatrician',
  'Psychiatrist',
  'Pulmonologist',
  'Radiologist',
  'Rheumatologist',
  'General Practitioner',
  'Family Medicine Physician'
]

const VisitTrackers = ({
  handleAddTracking,
  visits,
  handleUpdateTracker,
  handleRemoveTracker,
  planType,
  planLabel,
  specialistTypes
}) => {
  const { token } = theme.useToken()

  // Use provided specialist types or fallback to defaults
  const availableSpecialists = specialistTypes || DEFAULT_SPECIALIST_TYPES

  // Display the correct plan type in UI
  const displayLabel =
    planLabel || (planType ? planType.charAt(0).toUpperCase() + planType.slice(1) + ' Plan' : 'Care Plan')

  const filterChosenVisits = (item) => {
    let index = -1
    index = visits.findIndex((i) => i.dataKey === toCamelCase(item))
    return index === -1
  }

  return (
    <Card>
      <h1 style={{ color: token.colorPrimary }}>VISIT TRACKERS</h1>
      <p>Please select any doctor / specialist visits you want to track for this {displayLabel.toLowerCase()}.</p>
      <Card
        size='small'
        style={{ marginTop: 12 }}
        headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
        bodyStyle={{ padding: 0 }}
        title={
          <Space>
            <h2>Doctor Visits Tracking</h2>{' '}
            <Select
              placeholder='- Select Visit Trackers -'
              value={null}
              style={{ width: 500 }}
              onChange={(selection) => {
                try {
                  // Parse the selection to get the actual object
                  const parsedSelection = JSON.parse(selection)
                  // Make sure key property exists
                  if (parsedSelection && parsedSelection.key) {
                    // Create proper object structure for the tracker with dataKey properly set
                    const trackerObject = {
                      dataKey: parsedSelection.key,
                      dataLabel: parsedSelection.label,
                      count: 1,
                      trackerType: 'visits',
                      intervalDays: 180
                    }
                    handleAddTracking('visits', trackerObject, trackerObject)
                  } else {
                    console.error('Invalid selection format:', selection)
                  }
                } catch (err) {
                  console.error('Error parsing selection:', err)
                }
              }}
              showSearch
              options={availableSpecialists
                .filter((i) => filterChosenVisits(i))
                .map((type) => ({
                  label: type,
                  value: JSON.stringify({ key: toCamelCase(type), label: type })
                }))}
            />
          </Space>
        }
      >
        <Table
          size='small'
          bordered
          dataSource={visits}
          columns={CarePlanTemplatesNewRecordVisitsColumnTemplate(handleUpdateTracker, handleRemoveTracker)}
        />
      </Card>
    </Card>
  )
}

export default VisitTrackers
